import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext.jsx";

/** BT-053 / BT-COMPTES-ADMIN-001 — Redirect users with mandatory password change (backend + R0). */
export function PasswordChangeGuard() {
  const { isAuthenticated, canChangePassword, mustChangePassword } = useAuth();
  const location = useLocation();
  const onChangePage = location.pathname === "/changer-mot-de-passe";

  if (isAuthenticated && canChangePassword && mustChangePassword && !onChangePage) {
    // No `from` / returnTo — after password change, ChangePasswordPage navigates to /accueil.
    return <Navigate to="/changer-mot-de-passe" replace />;
  }

  return <Outlet />;
}
